import { Modal as RModal, Button, Placeholder, IconButton, Loader } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { selectModalState, updateModal } from './ModalSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { SplitterModalContent, TransceiverModalContent } from './ModalContent';
import { initialConfigState, recalcValues, selectConfigState, updateFieldsPack } from '../../features/calculator/calculatorSlice';
import { useState } from 'react';
import { splitterIDs } from '../../settings';
import './styles.scss'
import { MdOutlineSave, MdUTurnLeft } from 'react-icons/md';
enum ContentTypes {
    TRANSCEIVER_MODAL_CONTENT = "TransceiverModalContent",
    SPLITTER_MODAL_CONTENT = "SplitterModalContent",
}

const Modal = () => {
    const {
        open,
        headerTitle,
        content,
        cancelBtn,
        submitBtn,
        closeBtnTitle,
        submitBtnTitle,
        closeBtnAction,
        submitBtnAction,
        keyboard,
        backdrop,
        alertDialog,
        enableHeaderCloseBtn,
        submitBtnDisabled,
        submitBtnLoading
    } = useAppSelector(selectModalState);
    const configState = useAppSelector(selectConfigState);
    const dispatch = useAppDispatch();
    const confSate = {
        xgs_pon_tx_comb_trans: {
            gain_loss: configState.xgs_pon_tx_comb_trans.gain_loss
        },
        gpon_tx_comb_trans: {
            gain_loss: configState.gpon_tx_comb_trans.gain_loss
        },
        xgs_pon_rx_comb_trans_sens: {
            gain_loss: configState.xgs_pon_rx_comb_trans_sens.gain_loss
        },
        gpon_rx_comb_trans_sens: {
            gain_loss: configState.gpon_rx_comb_trans_sens.gain_loss
        },
        xgs_pon_tx_xgs_trans: {
            gain_loss: configState.xgs_pon_tx_xgs_trans.gain_loss
        },
        xgs_pon_rx_xgs_trans_sens: {
            gain_loss: configState.xgs_pon_rx_xgs_trans_sens.gain_loss
        },
        gpon_tx_gpon_trans: {
            gain_loss: configState.gpon_tx_gpon_trans.gain_loss
        },
        gpon_rx_gpon_sens: {
            gain_loss: configState.gpon_rx_gpon_sens.gain_loss
        },
    }

    const [transState, setTransState]: any = useState(confSate)

    const splittersData: any = {}; 

    splitterIDs.forEach((num: number) => {
        splittersData[`splitters_loss_1x${num}`] = {
            val: "",
            gain_loss: configState[`splitters_loss_1x${num}`].gain_loss
        }
    })

    const [splitterState, setSplitterState]: any = useState(splittersData)

    const handleTransChange = ({ id, val, valueID }: { id: string, val: any, valueID: string }) => {
        if (valueID) {
            setTransState({
                ...transState, [id]: {
                    ...transState[id],
                    [valueID]: val
                }
            })
        } else {
            setTransState({ ...transState, [id]: val })
        }
    }

    const handleSplitterChange = ({ id, val, valueID }: { id: string, val: any, valueID: string }) => {
        if (valueID) {
            setSplitterState({
                ...splitterState, [id]: {
                    ...splitterState[id],
                    [valueID]: val
                }
            })
        } else {
            setSplitterState({ ...splitterState, [id]: val })
        }
    }

    const handleClose = () => {
        closeBtnAction ? closeBtnAction() : dispatch(updateModal({ open: false }));
        switch (content) {
            case ContentTypes.TRANSCEIVER_MODAL_CONTENT:
                setTransState(confSate)
                break;
            case ContentTypes.SPLITTER_MODAL_CONTENT:
                const splittersData: any = {}; 
                splitterIDs.forEach((num: number) => {
                    splittersData[`splitters_loss_1x${num}`] = {
                        val: "",
                        gain_loss: configState[`splitters_loss_1x${num}`].gain_loss
                    }
                })
                setSplitterState(splittersData)
                break;
            default:
                break;
        }
    }
    const handleSubmit = () => {
        switch (content) {
            case ContentTypes.TRANSCEIVER_MODAL_CONTENT:
                dispatch(updateFieldsPack({ fieldsPack: transState }))
                dispatch(recalcValues())
                break;
            case ContentTypes.SPLITTER_MODAL_CONTENT:
                dispatch(updateFieldsPack({ fieldsPack: splitterState }))
                dispatch(recalcValues())
                break;
            default:
                submitBtnAction && submitBtnAction()
                break;
        }
        dispatch(updateModal({ open: false }))
    }
    const handleReset = () => {
        switch (content) {
            case ContentTypes.TRANSCEIVER_MODAL_CONTENT:
                setTransState({
                    xgs_pon_tx_comb_trans: {
                        gain_loss: initialConfigState.values.xgs_pon_tx_comb_trans.gain_loss
                    },
                    gpon_tx_comb_trans: {
                        gain_loss: initialConfigState.values.gpon_tx_comb_trans.gain_loss
                    },
                    xgs_pon_rx_comb_trans_sens: {
                        gain_loss: initialConfigState.values.xgs_pon_rx_comb_trans_sens.gain_loss
                    },
                    gpon_rx_comb_trans_sens: {
                        gain_loss: initialConfigState.values.gpon_rx_comb_trans_sens.gain_loss
                    },
                    xgs_pon_tx_xgs_trans: {
                        gain_loss: initialConfigState.values.xgs_pon_tx_xgs_trans.gain_loss
                    },
                    xgs_pon_rx_xgs_trans_sens: {
                        gain_loss: initialConfigState.values.xgs_pon_rx_xgs_trans_sens.gain_loss
                    },
                    gpon_tx_gpon_trans: {
                        gain_loss: initialConfigState.values.gpon_tx_gpon_trans.gain_loss
                    },
                    gpon_rx_gpon_sens: {
                        gain_loss: initialConfigState.values.gpon_rx_gpon_sens.gain_loss
                    },
                })
                break;
            case ContentTypes.SPLITTER_MODAL_CONTENT:
                const splittersData: any = {}; 
                splitterIDs.forEach((num: number) => {
                    splittersData[`splitters_loss_1x${num}`] = {
                        val: "",
                        gain_loss: initialConfigState.values[`splitters_loss_1x${num}`].gain_loss
                    }
                })
                setSplitterState(splittersData)
                break;
            default:
                submitBtnAction && submitBtnAction()
                break;
        }
    }

    let parsedContent;
    let modalBodyClass = ""
    switch (content) {
        case ContentTypes.TRANSCEIVER_MODAL_CONTENT:
            parsedContent = <TransceiverModalContent onChange={handleTransChange} state={transState} />
            break;
        case ContentTypes.SPLITTER_MODAL_CONTENT:
            parsedContent = <SplitterModalContent onChange={handleSplitterChange} state={splitterState} />
            modalBodyClass = "modal-body-flex"
            break;
        default:
            parsedContent = <Placeholder.Paragraph rows={1} />
            break;
    }
    const role = alertDialog ? 'alertdialog' : 'dialog'
    const resetButton = content === ContentTypes.TRANSCEIVER_MODAL_CONTENT || ContentTypes.SPLITTER_MODAL_CONTENT
    return <RModal
        role={role}
        backdrop={backdrop}
        keyboard={keyboard}
        open={open}
        onClose={handleClose}
        onKeyPress={(e: any) => {
            const disabled = submitBtnDisabled && submitBtnDisabled();
            if (!disabled && e.key === "Enter") {
                handleSubmit();
            }
        }}>
        {<RModal.Header closeButton={!alertDialog && enableHeaderCloseBtn}>
            <RModal.Title>{headerTitle}</RModal.Title>
        </RModal.Header>}
        <RModal.Body className={modalBodyClass}>
            {parsedContent}
        </RModal.Body>
        {open && <RModal.Footer>
            {cancelBtn && <Button onClick={handleClose} appearance="subtle">
                {closeBtnTitle}
            </Button>}
            {resetButton && <IconButton
                    className='rs-btn-cambium-icon'
                  appearance="ghost"
                  icon={<MdUTurnLeft size={22} style={{transform: 'rotate(90deg)'}}/>}
                  onClick={handleReset}
                >
                  Reset
                </IconButton>
            }
            {submitBtn && (
                submitBtnLoading && submitBtnLoading() ?
                    <IconButton
                        disabled={submitBtnDisabled && submitBtnDisabled()}
                        onClick={handleSubmit}
                        icon={
                            <Icon
                                as={Loader}
                                style={{ fontSize: 20 }}
                            />
                        }
                    /> :
                    <IconButton
                    disabled={submitBtnDisabled && submitBtnDisabled()}
                    className='rs-btn-cambium-icon'
                  appearance="primary"
                  icon={<MdOutlineSave size={22}/>}
                  onClick={handleSubmit}
                >
                  {submitBtnTitle}
                </IconButton>
                    
            )}
        </RModal.Footer>}
    </RModal>
}

export default Modal;